<template>
  <div>
    <sdPageHeader :title="$t('auth.profile_details')"> </sdPageHeader>
    <div class="change-password-btn">

      <a-button type="primary" @click="togglePasswordModal">{{
        $t("auth.want_new_password")
      }}</a-button>

      <a-modal
        v-model:visible="visible"
        :title="$t('auth.want_new_password')"
        :type="modalType"
      >
        <template #footer>
          <a-button key="back" @click="handleCancel">{{
            $t("generic.buttons.cancel")
          }}</a-button>
          <a-button
            key="submit"
            type="primary"
            :loading="passwordLoading"
            @click="handleChangePassword"
            >{{ $t("generic.buttons.ok") }}</a-button
          >
        </template>

        <!-- <div class="modal-title">
        {{ $t('auth.want_new_password') }}
      </div> -->
        <div class="modal-form">
          <a-form
            layout="vertical"
            :model="changePasswordState"
            class="new-password-form"
            :rules="rules"
          >
            <!-- <label>{{ $t("auth.password") }}</label> -->

            <a-form-item :label="$t('auth.password')" name="oldPassword">
              <a-input
                type="password"
                v-model:value="changePasswordState.oldPassword"
              />
            </a-form-item>

            <!-- <label>{{ $t("auth.new_password") }}</label> -->

            <a-form-item :label="$t('auth.new_password')" name="newPassword">
              <a-input
                type="password"
                v-model:value="changePasswordState.newPassword"
              />
            </a-form-item>

            <!-- <label>{{ $t("auth.repeat_new_password") }}</label> -->

            <a-form-item
              :label="$t('auth.repeat_new_password')"
              name="repeatNewPassword"
            >
              <a-input
                type="password"
                v-model:value="changePasswordState.repeatNewPassword"
              />
            </a-form-item>
          </a-form>
        </div>
      </a-modal>
    </div>
    <a-row justify="center" class="user-account-detail-form">
      <a-col :lg="12" :md="16" :sm="20" :xs="24">
        <a-form
          :model="formState"
          layout="vertical"
          :labelCol="{ span: 24, offset: 0 }"
          :wrapperCol="{ span: 24 }"
        >
          <a-row>
            <a-col :span="12" class="px-2">
              <a-form-item
                :label="$t('auth.name')"
                name="firstname"
                :rules="[
                  { required: true, message: $t('auth.required_field_error') },
                ]"
              >
                <a-input
                  v-model:value="formState.firstname"
                  :placeholder="$t('auth.name')"
                  :disabled="!isEditing"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12" class="px-2">
              <a-form-item
                :label="$t('auth.lastname')"
                name="lastname"
                :rules="[
                  { required: true, message: $t('auth.required_field_error') },
                ]"
              >
                <a-input
                  v-model:value="formState.lastname"
                  :placeholder="$t('auth.lastname')"
                  :disabled="!isEditing"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24" class="px-2">
              <a-form-item
                :label="$t('auth.email')"
                name="email"
                :rules="[
                  { required: true, message: $t('auth.required_field_error') },
                ]"
              >
                <a-input
                  v-model:value="formState.email"
                  :placeholder="$t('auth.email')"
                  type="email"
                  :disabled="!isEditing"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24" class="px-2">
              <a-form-item
                :label="$t('auth.phone')"
                name="phone"
                :rules="[
                  { required: true, message: $t('auth.required_field_error') },
                ]"
              >
                <a-input
                  v-model:value="formState.phone"
                  :placeholder="$t('auth.phone')"
                  type="tel"
                  :disabled="!isEditing"
                />
              </a-form-item>
            </a-col>
            <a-col :span="24" class="px-2">
              <a-form-item
                :label="$t('auth.bank')"
                name="bank"
              >
                <a-select
                  v-model:value="formState.bank"
                  :placeholder="$t('auth.bank')"
                  :disabled="!isEditing"
                >
                  <a-select-option
                    v-for="item in authStore.banks"
                    :key="item.id"
                    :title="item.name"
                  >
                    {{ item.name }}
                  </a-select-option>        
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="authStore.activePlan">
            <strong>
              {{ t('generic.titles.active_plan') }}: {{ authStore.activePlan.name }}
            </strong>
          </a-row>
          <!-- <a-row v-if="authStore.cb_loading">
            <a-col v-for="i in [1,2,3]" :key="i" :xs="24" :sm="12" :lg="8" class="px-1 py-2">
              <a-card
                :style="{
                  'box-shadow': '0 1px 2px 0 rgba(0,0,0,.1)',
                  'height': '100%',
                }"
                :loading="true"
              />
            </a-col>
          </a-row>
          <a-row v-else>   
            <a-col v-for="cb_plan in authStore.cb_plans" :key="cb_plan.id" :xs="24" :sm="12" :lg="8" class="px-1 py-2">
              <a-card
                :style="{
                  'box-shadow': '0 1px 2px 0 rgba(0,0,0,.1)',
                  'height': '100%',
                  'border': isPlanActive(cb_plan) ? '2px solid #35b7d9' : 'none'
                }"
              >
                <div class="flex flex-column justify-content-between h-100">
                  <div>
                    <div class="text-center" style="height: 64px;">
                      <strong>
                        {{ cb_plan.name }}
                      </strong>
                    </div>
                    <div class="mt-2 flex justify-content-between align-items-center w-100">
                      <span>{{ t('generic.titles.price') }}:</span> {{ cb_plan.price }}
                    </div>
                    <div class=" flex justify-content-between align-items-center w-100">
                      <span>{{ t('generic.titles.period') }}:</span> {{ cb_plan.period }} {{ cb_plan.period_unit }}
                    </div>
                    <div class=" flex justify-content-between align-items-center w-100">
                      <span>{{ t('generic.titles.currency_code') }}:</span> {{ cb_plan.currency_code }}
                    </div>
                  </div>
                  <a-checkbox class="mt-2" v-model:checked="cb_plan.agreeTerms" :disabled="isPlanActive(cb_plan)">
                    <span style="font-size: 12px;">
                      {{ t('generic.titles.agreement_label') }}
                      <span>
                        <a v-if="isPlanActive(cb_plan)" class="blank-link" href="https://brokvisor.com/aviso-legal/" target="_blank">{{ t('generic.titles.terms_of_service') }}</a>
                        <span v-else>{{ t('generic.titles.terms_of_service') }}</span>
                      </span>
                      {{ t('generic.titles.and') }}
                      <span>
                        <a v-if="isPlanActive(cb_plan)" class="blank-link" href="https://brokvisor.com/politica-de-privacidad/" target="_blank">{{ t('generic.titles.privacy_policy') }}</a>
                        <span v-else>{{ t('generic.titles.privacy_policy') }}</span>
                      </span>
                    </span>
                  </a-checkbox>
                  <div class=" flex justify-content-center align-items-center w-100">
                    <a-button
                      type="primary"
                      class="mt-2"
                      @click="checkoutPlan(cb_plan)"
                      :disabled="isPlanActive(cb_plan) || !cb_plan.agreeTerms"
                    >Buy</a-button>
                  </div>
                </div>
              </a-card>
            </a-col>
          </a-row> -->
          <!--  -->
          <a-row justify="center" class="mb-5 mt-4">
            <template v-if="!isEditing">
              <a-button
                type="primary"
                @click="toggleEditMode"
                >{{ $t("auth.edit_account") }}</a-button
              >
              <a-button
                style="margin-left: 8px;"
                type="primary"
                @click="openChargebeePortal()"
                :loading="cbLoginLoading"
              >
                {{ $t("auth.cb_account") }}
              </a-button>
              <a-button
                style="margin-left: 8px;"
                type="primary"
                @click="openCreditModal()"
                :loading="authStore.loadingTokens"
                v-if="!authStore.restrictions.includes(Restrictions['ApiKeyManagement'])"
              >
                {{ $t("auth.purchase_credits") }}
              </a-button>
            </template>

            <template v-else>
            <a-button
              type="primary"
                style="margin-right: 4px;"
              :loading="userDataLoading"
              :disabled="!isEnabled"
              @click="saveUserData"
                >{{ $t("auth.save_changes") }}
              </a-button>
              <sdButton
                type="primary"
                size="sm"
                :outlined="true"
                :loading="userDataLoading"
                @click="toggleEditMode"
                >{{ $t("generic.buttons.cancel") }}
              </sdButton>
            </template>
          </a-row>
        </a-form>
      </a-col>
    </a-row>
    <!-- <a-modal
      v-model:visible="showCheckoutModal"
      :closable="false"
      :footer="null"
    >
      <div
        class="flex justify-content-center align-items-center w-100"
        style="height: 600px"
        v-if="hostedPageLoading"
      >
        <a-spin></a-spin>
      </div>
      <div
        :style="{'height': hostedPageLoading ? '0' : '600px'}"
      >
        <iframe
          ref="iframeRef"
          :src="checkoutUrl"
          width="100%"
          height="100%"
          frameborder="0"
        ></iframe>
      </div>
    </a-modal> -->
    <a-modal
      v-model:visible="cbAccountModal"
      :closable="false"
      :footer="null"
    >
      <div
        class="flex justify-content-center align-items-center w-100"
        style="height: 600px"
        v-if="cbAccountLoading"
      >
        <a-spin></a-spin>
      </div>
      <div
        style="position: relative;"
        :style="{'height': cbAccountLoading ? '0' : '600px'}"
      >
        <iframe
          ref="iframeRef"
          :src="chargebeePortal"
          width="100%"
          height="100%"
          frameborder="0"
          class="cb-portal-frame"
        ></iframe>
      </div>
      <div class="d-flex justify-content-center">
        <sdButton
          type="primary"
          size="sm"
          :outlined="true"
          class="mt-3"
          @click="closePortal()"
        >{{ $t("generic.buttons.close") }}
        </sdButton>
      </div>
    </a-modal>
    <a-modal
      v-model:visible="creditModal"
      :footer="null"
    >
      <div class="credit-modal-body">
        <h4>{{ t('auth.api_keys') }}</h4>
        <p style="display: flex; align-items: start;">
          {{ t('auth.manage_keys') }}
          <a-tooltip :title="apiKeyInfo">
            <wiser-icon icon="info" style="scale: 0.8;"></wiser-icon>
          </a-tooltip>
        </p>
        <a-button
          type="primary"
          @click="createKey()"
          :loading="authStore.loadingCreateToken"
        >
          {{ $t("auth.create_key") }}
        </a-button>
        <div class="mt-4 w-100">
          <a-table
            :columns="keyTableColumns"
            :data-source="keyTableData"
            rowKey='id'
          >
          </a-table>
        </div>
      </div>
    </a-modal>
    <a-modal
      v-model:visible="creditAmountModal"
      :footer="null"
    >
      <a-row>
        <a-col style="text-align: center;">
          <label class="mb-2">{{ t('auth.credit_amount_to_purchase') }}</label>
        </a-col>
        <a-col :xs="24">
          <a-input-number
            style="width: 100%; height: 40px;"
            v-model:value="creditAmount"
            :min="1"
          />
        </a-col>
        <a-col :xs="24">
          <sdButton
            type="primary"
            size="sm"
            class="mt-3 w-100"
            @click="showConfirmationModal"
            :loading="authStore.loadingAddCredits"
          >
            {{ $t("generic.buttons.pay") }}
          </sdButton>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal v-model:visible="confirmationModalVisible" :footer="null">
      <label class="mb-2">{{ t('auth.confirm_payment') }}</label>
      <div style="text-align: center;">
        <sdButton type="primary" @click="confirmPurchase">
          {{ $t('generic.buttons.ok') }}
        </sdButton>
        <sdButton class="ml-2" @click="confirmationModalVisible = false">
          {{ $t('generic.buttons.cancel') }}
        </sdButton>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { Modal } from "ant-design-vue";
import { ref, reactive, computed, watch, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import WiserIcon from "@/components/icons/wiser-icons";
import { useAuthStore } from "@/stores/AuthStore";
import { message } from "ant-design-vue";
import Restrictions from "@/config/restriction/restrict_functions";

const { t } = useI18n();
const authStore = useAuthStore();

const isEditing = ref(false);
const visible = ref(false);
const userDataLoading = ref(false);
const passwordLoading = ref(false);
// const checkoutUrl = ref('');
const selectedToken = ref('');
const creditAmountModal = ref(false);
const confirmationModalVisible = ref(false);
const creditAmount = ref(1);
const showCheckoutModal = ref(false);
const cbAccountModal = ref(false);
const creditModal = ref(false);
const hostedPageLoading = ref(false);
const cbAccountLoading = ref(false);
const cbLoginLoading = ref(false);
const iframeRef = ref();

const chargebeeUrl = `https://${process.env.VUE_APP_CHARGEBEE_SITE_NAME}.chargebee.com`;
const chargebeePortal = ref('');
const shownTokens = ref([]);

const apiKeyInfoFields = [
  {
    labelKey: 'api_operation',
    field: 'operation',
  },
  {
    labelKey: 'api_cost',
    field: 'cost'
  }
];
const apiKeyInfoData = [
  {
    operation: 'Get Macro Data',
    cost: 0.0001
  },
  {
    operation: 'Get General Macro Data',
    cost: 0.001
  },
  {
    operation: 'Get User Portfolio List',
    cost: 0.001
  },
  {
    operation: 'Get User Portfolios',
    cost: 0.0001
  },
  {
    operation: 'Get Asset Reports',
    cost: 0.0001
  },
  {
    operation: 'Generate Portfolio Advanced',
    cost: 0.0001
  },
  {
    operation: 'Optimize Weights',
    cost: 0.0001
  },
  {
    operation: 'Generate Ratios',
    cost: 0.01
  },
  {
    operation: 'Rank ISINs',
    cost: 0.01
  },
  {
    operation: 'Send Portfolio Summary Mail',
    cost: 0.01
  },
  {
    operation: 'Send Portfolio Summary Mail from Dataframe',
    cost: 0.01
  },
  {
    operation: 'Get Bests',
    cost: 0.0001
  },
  {
    operation: 'Get Masters',
    cost: 0.0001
  },
  {
    operation: 'Get Searches',
    cost: 0.0001
  },
  {
    operation: 'Get Valorations',
    cost: 0.0001
  },
  {
    operation: 'Get Compositions',
    cost: 0.0001
  },
  {
    operation: 'Import Portfolios',
    cost: 0.0001
  },
  {
    operation: 'Get Portfolio Reports',
    cost: 0.001
  }
];


const apiKeyInfo = computed(() => {
  return (
    <table>
      <tr>
        { apiKeyInfoFields.map((col) => (
          <th style={{padding: '2px 8px'}}>
            { t(`auth.${col.labelKey}`) }
          </th>
        ))}
      </tr>
      { apiKeyInfoData.map(row => (
        <tr>
          { apiKeyInfoFields.map(col => (
            <td style={{padding: '2px 8px'}}>{row[col.field]}</td>
          ))}
        </tr>
      ))}
    </table>
  )
});

const keyTableColumns = [
{
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Token',
    dataIndex: 'token',
    key: 'token',
    customRender: ({ record }) => {
      return <div style="display: flex; align-items: center; gap: 4px;">
        <div style="width: 140px;">
          { !shownTokens.value.includes(record.token) ?
            <span style="padding-top: 8px;">**********************</span> :
            <input
              style="width: 90%; outline: none; border-color: lightgrey;"
              type="text"
              value={record.token}
              readonly
            />
          }
        </div>
        <svg
          style="cursor: pointer;"
          width="12px"
          height="12px"
          viewBox="0 0 24 24"
          fill="none"
          onClick={() => toggleRevealToken(record.token)}
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.2954 6.31083C22.6761 6.474 22.8524 6.91491 22.6893 7.29563L21.9999 7.00019C22.6893 7.29563 22.6894 7.29546 22.6893 7.29563L22.6886 7.29731L22.6875 7.2998L22.6843 7.30716L22.6736 7.33123C22.6646 7.35137 22.6518 7.37958 22.6352 7.41527C22.6019 7.48662 22.5533 7.58794 22.4888 7.71435C22.3599 7.967 22.1675 8.32087 21.9084 8.73666C21.4828 9.4197 20.8724 10.2778 20.0619 11.1304L21.0303 12.0987C21.3231 12.3916 21.3231 12.8665 21.0303 13.1594C20.7374 13.4523 20.2625 13.4523 19.9696 13.1594L18.969 12.1588C18.3093 12.7115 17.5528 13.2302 16.695 13.6564L17.6286 15.0912C17.8545 15.4383 17.7562 15.9029 17.409 16.1288C17.0618 16.3547 16.5972 16.2564 16.3713 15.9092L15.2821 14.2353C14.5028 14.4898 13.659 14.6628 12.7499 14.7248V16.5002C12.7499 16.9144 12.4141 17.2502 11.9999 17.2502C11.5857 17.2502 11.2499 16.9144 11.2499 16.5002V14.7248C10.3689 14.6647 9.54909 14.5004 8.78982 14.2586L7.71575 15.9093C7.48984 16.2565 7.02526 16.3548 6.67807 16.1289C6.33089 15.903 6.23257 15.4384 6.45847 15.0912L7.37089 13.689C6.5065 13.2668 5.74381 12.7504 5.07842 12.1984L4.11744 13.1594C3.82455 13.4523 3.34968 13.4523 3.05678 13.1594C2.76389 12.8665 2.76389 12.3917 3.05678 12.0988L3.98055 11.175C3.15599 10.3153 2.53525 9.44675 2.10277 8.75486C1.83984 8.33423 1.6446 7.97584 1.51388 7.71988C1.44848 7.59182 1.3991 7.48914 1.36537 7.41683C1.3485 7.38067 1.33553 7.35207 1.32641 7.33167L1.31562 7.30729L1.31238 7.29984L1.31129 7.29733L1.31088 7.29638C1.31081 7.2962 1.31056 7.29563 1.99992 7.00019L1.31088 7.29638C1.14772 6.91565 1.32376 6.474 1.70448 6.31083C2.08489 6.1478 2.52539 6.32374 2.68888 6.70381C2.68882 6.70368 2.68894 6.70394 2.68888 6.70381L2.68983 6.706L2.69591 6.71972C2.7018 6.73291 2.7114 6.7541 2.72472 6.78267C2.75139 6.83983 2.79296 6.92644 2.84976 7.03767C2.96345 7.26029 3.13762 7.58046 3.37472 7.95979C3.85033 8.72067 4.57157 9.70728 5.55561 10.6218C6.42151 11.4265 7.48259 12.1678 8.75165 12.656C9.70614 13.0232 10.7854 13.2502 11.9999 13.2502C13.2416 13.2502 14.342 13.013 15.3124 12.631C16.5738 12.1345 17.6277 11.3884 18.4866 10.5822C19.4562 9.67216 20.1668 8.69535 20.6354 7.9434C20.869 7.5685 21.0405 7.25246 21.1525 7.03286C21.2085 6.92315 21.2494 6.83776 21.2757 6.78144C21.2888 6.75328 21.2983 6.73242 21.3041 6.71943L21.31 6.70595L21.3106 6.70475C21.3105 6.70485 21.3106 6.70466 21.3106 6.70475M22.2954 6.31083C21.9147 6.14771 21.4738 6.32423 21.3106 6.70475L22.2954 6.31083ZM2.68888 6.70381C2.68882 6.70368 2.68894 6.70394 2.68888 6.70381V6.70381Z"
              fill="currentColor"
            ></path>
          </g>
        </svg>
        <svg
          style="cursor: pointer;"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          onClick={() => copyToClipboard(record.token)}
        >
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
          <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
        </svg>
      </div>
    }
  },
  {
    title: 'Credits',
    dataIndex: 'credits',
    key: 'credits',
  },
  {
    title: 'Actions',
    key: 'actions',
    dataIndex: 'actions',
    customRender: ({ record }) => {
      return <a-button onClick={() => openCreditAmountModal(record)}>
        { t('generic.buttons.purchase') }
      </a-button>
    }
  },
];

const keyTableData = computed(() => {
  return authStore.user_tokens.map(token => {
    return {
      ...token,
      key: token.id
    };
  });
});

const showConfirmationModal = () => {
  confirmationModalVisible.value = true;
};

const copyToClipboard = async (token) => {
  try {
    await navigator.clipboard.writeText(token);
    message.success(t('auth.copy_token'));
    return true;
  } catch (err) {
    console.error("Error al copiar al portapapeles:", err);
    return false;
  }
};

const toggleRevealToken = (token) => {
  if (shownTokens.value.includes(token)) {
    shownTokens.value = shownTokens.value.filter(t => t !== token);
  } else {
    shownTokens.value.push(token);
  }
};

const openCreditAmountModal = (record) => {
  selectedToken.value = record?.token ?? '';
  creditAmountModal.value = true;
};

// const purchaseCredits = async () => {
//   try {
//     await authStore.purchaseCredits(selectedToken.value, creditAmount.value).then(() => {
//       creditAmountModal.value = false;
//     });
//     message.success(t('auth.confirmed_purchase'));
//   } catch (error) {
//       creditAmountModal.value = false;
//       authStore.loadingAddCredits = false;
//       console.error("Error al comprar creditos:", error);
//       console.log("Error al comprar creditos:", error);
//   }
// };

const confirmPurchase = async () => {
  confirmationModalVisible.value = false;
  try {
    await authStore.purchaseCredits(selectedToken.value, creditAmount.value).then(() => {
      creditAmountModal.value = false;
    });
    message.success(t('auth.confirmed_purchase'));
  } catch (error) {
    creditAmountModal.value = false;
    authStore.loadingAddCredits = false;
    console.error("Error al comprar créditos:", error);
  }
};

onMounted(() => {
  window.addEventListener('message', function(event) {
    if (event.origin === chargebeeUrl && event.data === 'cb.close') {
      hostedPageLoading.value = false;
      showCheckoutModal.value = false;
    }
  });
});

watch(
  () => iframeRef.value,
  () => {
    if (iframeRef.value) {
      cbAccountLoading.value = true;
      hostedPageLoading.value = true;
      iframeRef.value.onload = () => {
        cbAccountLoading.value = false;
        hostedPageLoading.value = false;
      };
    }
  }
);

const originalData = {
  id: authStore.user.id,
  firstname: authStore.user.firstname,
  lastname: authStore.user.lastname,
  email: authStore.user.email,
  phone: authStore.user.phone,
  bank: authStore.user.bank,
};

const formState = reactive({ ...originalData });

function resetForm() {
  Object.assign(formState, originalData);
}

const changePasswordState = reactive({
  oldPassword: "",
  newPassword: "",
  repeatNewPassword: "",
});

let confirmPassword = async (rule, value) => {
  if (value === "") {
    return Promise.reject(t("auth.rules.repeat_new_password"));
  } else if (value !== changePasswordState.newPassword) {
    return Promise.reject(t("auth.rules.passwords_dont_match"));
  } else {
    return Promise.resolve();
  }
};

const rules = {
  oldPassword: [
    { required: true, message: t("auth.rules.password"), trigger: "blur" },
  ],
  newPassword: [
    { required: true, message: t("auth.rules.new_password"), trigger: "blur" },
  ],
  repeatNewPassword: [
    { required: true, validator: confirmPassword, trigger: "change" },
  ],
};

const handleChangePassword = async () => {
  if (
    changePasswordState.newPassword &&
    changePasswordState.repeatNewPassword &&
    changePasswordState.newPassword === changePasswordState.repeatNewPassword
  ) {
    passwordLoading.value = true;
    await authStore.changePassword(changePasswordState).then(() => {
      visible.value = false;
      passwordLoading.value = false;

      authStore.success ? success() : "";
    });
  }
};

const toggleEditMode = () => (isEditing.value = !isEditing.value);

const form = { ...formState };

const isEnabled = computed(() => {
  return Object.keys(form).some((field) => form[field] !== formState[field]);
});

const success = () => {
  Modal.success({
    title: t("generic.titles.changes_ok"),
    content: t("message.changes_applied"),
    onOk() {
      authStore.success = false;
    },
  });
};

const saveUserData = async () => {
  try {
    userDataLoading.value = true;
    await authStore.editUser(formState).then(() => {
      userDataLoading.value = false;
      authStore.success ? success() : "";
    });
  } catch (err) {
    userDataLoading.value = false;
    message.error(t("auth.forgot_password_error"));
    resetForm();
    console.log(err);
  }

  toggleEditMode();
};

const togglePasswordModal = () => (visible.value = !visible.value);

// const isPlanActive = (cb_plan) => {
//   return authStore?.cb_subscriptions?.find(item => 
//     item?.subscriptionItems?.find(sub_item => sub_item?.itemPriceId === cb_plan?.id) && 
//     item?.customer?.email === authStore?.user?.email
//   );
// };

// const checkoutPlan = (cb_plan) => {
//   showCheckoutModal.value = true;
//   checkoutUrl.value = cb_plan.hostedPageUrl + 'cart';
// };

const openCreditModal = async () => {
  await authStore.getTokens();
  creditModal.value = true;
};

const createKey = async () => {
  await authStore.createToken();
};

const openChargebeePortal = () => {
  cbLoginLoading.value = true;
  authStore.loginChargebee().then(res => {
    chargebeePortal.value = `https://${process.env.VUE_APP_CHARGEBEE_SITE_NAME}.chargebee.com/portal/v2/authenticate?token=${res.data.token}`;
    cbLoginLoading.value = false;
    cbAccountModal.value = true;
  });
};

const closePortal = () => {
  cbAccountModal.value = false;
  cbAccountLoading.value = false;
};

onMounted(async () => {
  await authStore.getBanks();
  await authStore.getActivePlan();
});
</script>

<style scoped lang="scss">
.user-account-detail-form {
  max-width: 1500px;
  margin: 0 auto;
}

.ant-card-body {
  height: 100%;
}

.change-password-btn {
  max-width: 95%;
  margin: 0px auto 40px auto;
  display: flex;
  justify-content: flex-end;
  @media only screen and (max-width: 1149px) {
    width: 100%;
    justify-content: center;
  }
}

.modal-form {
  & > * {
    margin: 5px 0;
    width: 95%;
  }
}

.new-password-form {
  & > * {
    margin-bottom: 15px;
  }

  label {
    margin: 2px 0;
  }
}

.blank-link {
  font-weight: 500;
  color: #09aba0;
}
.blank-link:hover {
  text-decoration: underline !important;
}
.close-portal {
  cursor: pointer;
  width: 2rem;
  height: 2rem;
}
.plan-card {
  box-shadow: '0 1px 2px 0 rgba(0,0,0,.1)';
  width: 300px;
  height: '100%';
}
.credit-modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
</style>
